module.exports = __webpack_public_path__ + "img/hb_round_img3.65d7e143.png";